module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"uk":{"defaultTitle":"Хто викладає","follow":"Читати","following":"Читаєте","toPortfolio":"До портфоліо"},"en":{"defaultTitle":"Our teachers","follow":"Follow","following":"Following","toPortfolio":"To portfolio"}}')
  delete Component.options._Ctor
}
